import * as types from "./actionTypes";

export function beadsLoaded(beads) {
    
    return {
        type: types.BEADS_LOADED,
        body: beads
    };    
}

export function voortgangsrapportBeadsLoaded(beads) {
    
    return {
        type: types.VOORTGANGSRAPPORT_BEADS_LOADED,
        body: beads
    };    
}